module.exports = __webpack_public_path__ + "04_short_gray.9a3e8e24.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/04_short_gray.png
// module id = qd74
// module chunks = 0